import { render, staticRenderFns } from "./post-activation-survey.vue?vue&type=template&id=08493a55&"
import script from "./post-activation-survey.vue?vue&type=script&lang=js&"
export * from "./post-activation-survey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports